import { render } from "./ChoosingWecobi.vue?vue&type=template&id=62ae7cfe&scoped=true"
import script from "./ChoosingWecobi.vue?vue&type=script&lang=js"
export * from "./ChoosingWecobi.vue?vue&type=script&lang=js"

import "./ChoosingWecobi.vue?vue&type=style&index=0&id=62ae7cfe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ae7cfe"]])

export default __exports__